<template>
    <Modal v-if="showModal" @close="$emit('close')" :titleBgColor="'#f68420'" :background="background">
        <template #header>
            <h2 class="flex1 modal_title">
                排序</h2>
        </template>
        <div class="modal_filter">
            <div class="key_title">
                <div class="key_text">难易度</div>
                <div class="key_icon">
                    <img src="@/assets/img/taiko/songs/arrow_down.png" width="22" alt="">
                </div>
            </div>
            <div class="option">
                <div class="icon_row">
                    <img class="icon" :class="{ icon_red: level === 10 }" width="36" src="@/assets/img/taiko/songs/10000.png"
                        @click="swtichToLevel(10)" alt="" />
                    <img class="icon" :class="{ icon_red: level === 1 }" width="36" src="@/assets/img/taiko/songs/10005.png"
                        @click="swtichToLevel(1)" alt="" />
                    <img class="icon" :class="{ icon_red: level === 2 }" width="36" src="@/assets/img/taiko/songs/10001.png"
                        @click="swtichToLevel(2)" alt="" />
                    <img class="icon" :class="{ icon_red: level === 3 }" width="36" src="@/assets/img/taiko/songs/10002.png"
                        @click="swtichToLevel(3)" alt="" />
                    <img class="icon" :class="{ icon_red: level === 4 }" width="36" src="@/assets/img/taiko/songs/10003.png"
                        @click="swtichToLevel(4)" alt="" />
                    <img class="icon" :class="{ icon_red: level === 5 }" width="36" src="@/assets/img/taiko/songs/10004.png"
                        @click="swtichToLevel(5)" alt="" />
                </div>
            </div>
            <div class="key_title">
                <div class="key_text">升/降序</div>
                <div class="key_icon">
                    <img src="@/assets/img/taiko/songs/arrow_down.png" width="22" alt="">
                </div>
            </div>
            <div class="option">
                <div class="sort_row">
                    <div class="sort_button" :class="{ choose: sortUp==1 }" @click="selcetSort(1)">
                        升序<img v-if="sortUp!=1" src="@/assets/img/taiko/songs/arrow_b.png" /><img v-else src="@/assets/img/taiko/songs/arrow_w.png" />
                    </div>
                    <div class="sort_button up_btn" :class="{ choose: sortUp==0 }" @click="selcetSort(0)">
                        降序<img v-if="sortUp!=0" src="@/assets/img/taiko/songs/arrow_b.png" /><img v-else src="@/assets/img/taiko/songs/arrow_w.png" />
                    </div>
                </div>
            </div>
            <div class="key_title">
            </div>
            <div class="option">
                <div class="sort_row">
                    <div class="sort_button" @click="enterFilter(false)">
                        重置
                    </div>
                    <div class="sort_button enter" @click="enterFilter(true)">
                        确定
                    </div>
                </div>
            </div>
        </div>
    </Modal>
</template>
<script>
import Modal from '@/components/Modal'

export default {
    data() {
        return {
            level: 0,
            sortUp: -1,
            isData: true
        }
    },
    components: {
        Modal,
    },
    props: {
        background: String,
        showModal: Boolean,
        filterData: Object,
    },
    methods: {
        swtichToLevel(data) {
            //0代表全部，10代表亲子
            this.level = data
            this.selcetSort(1)
        },
        selcetSort(data) {
            this.sortUp = data
        },
        enterFilter(data) {
            this.isData = data
            // console.log(this.isData)
            if (data) {
                this.$emit('filterData', {
                    level: this.level,
                    sortUp: this.sortUp
                })
                this.$emit('close')
            }else{
                this.level = 0
                this.sortUp = -1
            }
        }
    },
}
</script>

<style lang="scss" scoped>
.flex1 {
    flex: 1;
}

.modal_title {
    color: rgb(255, 255, 255);
    font-weight: 800;
    text-align: center;
    font-size: 22px;
    margin-left: 28px;
}

.modal_filter {
    // margin: 5px 20px;
    width: 100%;

    .key_title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0px 25px;
        height: 50px;

        .key_text {
            font-size: 18px;
            font-weight: 600;
            color: #3b3b3b;
        }

        .key_icon {}
    }

    .option {
        padding: 10px 0;
        background-color: #f6f6f6;

        .icon_row {
            flex: 1;
            margin: 0 8px;
            display: flex;
            justify-content: space-around;
            align-items: center;
        }

        .icon_red {
            padding: 6px 1px;
            border: 3px solid #de6458;
            border-radius: 20%;
        }

        .sort_row {
            display: flex;
            justify-content: space-around;
            flex: 1;
            align-items: center;
            margin: 0 8px;
            font-size: 18px;
            font-weight: 600;

            .sort_button {
                width: 160px;
                text-align: center;
                vertical-align: middle;
                border-radius: 10px;
                background-color: #d9d9d9;
                color: #3b3b3b;
                padding: 7px 0;
                img{
                    height: 14px;
                    width: auto;
                    margin-left: 5px;
                    vertical-align: middle;
                }
            }
            .up_btn{
                img{
                    transform: rotate(180deg);
                }
            }

            .choose {
                background-color: #e65e54;
                color: #FFF;
            }

            .enter {
                background-color: #f68420;
                color: #FFF;
            }
        }
    }

}
</style>